import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CourseSchedule } from '../../models/course-schedule';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-course-schedule-tile',
    templateUrl: './course-schedule-tile.component.html',
    styleUrls: ['./course-schedule-tile.component.scss'],
    standalone: false
})
export class CourseScheduleTileComponent implements OnInit {
   @Input() trainingSchedule: CourseSchedule;
   @Input() isWorker:boolean=false;
  currentLang: string = 'en'
  seatsAvailable: number
  viewDetails:boolean=false

  constructor(public translateService: TranslateService,
    public router: Router,
    public route: ActivatedRoute) {
    this.currentLang = translateService.currentLang
    translateService.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang
    })
   }

  ngOnInit(): void {
    this.seatsAvailable = this.trainingSchedule.getSeatsAvailable()
  }

  NavigateToEnrol():void{
    let elecs = this.trainingSchedule?.ElectronicAddresses ?? [];
  
    if (elecs.some(x => x.TypeName === 'VirtualClassUrl')) {
      const virtualClassUrl = elecs.find(x => x.TypeName === 'VirtualClassUrl')?.ElectronicAddressValue;
      if (virtualClassUrl) {
        window.open(virtualClassUrl, '_blank');
      }
    } else if (elecs.some(x => x.TypeName === 'ExternalRegistrationUrl')) {
      const externalRegistrationUrl = elecs.find(x => x.TypeName === 'ExternalRegistrationUrl')?.ElectronicAddressValue;
      if (externalRegistrationUrl) {
        window.open(externalRegistrationUrl, '_blank');
      }
    } else {
    this.isWorker?  this.router.navigate(['marketplace/enrolment/'+ this.trainingSchedule.CourseId + '/worker']):
      this.router.navigate(['/marketplace/enrolment/' + this.trainingSchedule.CourseId]);
    }

  }
}
